import React from 'react';
import { RegularPOList } from './RegularPOList';
import { RACAccordion, makeStyles, Typography } from '@rentacenter/racstrap';
import { POSection } from '../../constants/constants';
import { SectionProps } from './ReceivingPO';
export const manualPOTestId = 'manualPOTestId';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  receivingPOManualRoot: {
    margin: `${theme.typography.pxToRem(16)} 0`,
  },
  h4: {
    marginTop: '.5rem',
  },
  accordionSummaryContent: {
    margin: '0 !important',
  },
}));

export const RegularPOSection = ({ selected, onChange }: SectionProps) => {
  // eslint-disable-next-line no-console
  console.log('inside RegularPOSection component');
  const classes = useStyles();
  const expanded = selected === POSection.RegularPO;
  const { t } = useTranslation();

  return (
    <>
      <RACAccordion
        details={<RegularPOList expanded={expanded} />}
        defaultExpanded
        summary={
          <>
            <Typography variant="h4" className={classes.h4}>
              {t('PO Receiving')}
            </Typography>
          </>
        }
        accordionProps={{
          classes: {
            root: classes.receivingPOManualRoot,
          },
          expanded: expanded,
          onChange: onChange(expanded ? '' : POSection.RegularPO),
        }}
        summaryProps={{
          classes: {
            content: classes.accordionSummaryContent,
          },
        }}
      />
    </>
  );
};
